// extracted by mini-css-extract-plugin
export var hidden = "_sz-0";